<template>
  <nav class="sidebar">
    <ul class="list-unstyled components">
      <!-- Produtos 1 -->
      <li>
        <b-link v-b-toggle="'produtos-1'">
          Processamento 2D em tempo
        </b-link>
        <b-collapse id="produtos-1" tag="ul" class="list-unstyled">
          <li>
            <b-link to="/products/1/controle-qualidade">
              Controle de qualidade
            </b-link>
          </li>
          <li>
            <b-link to="/products/1/correcao-estatica-tomografia">
              Correção estática por tomografia
            </b-link>
          </li>
          <!-- <li>
            <b-link to="/products/1/eliminacao-eventos-anomalos">
              Eliminação de eventos anômalos
            </b-link>
          </li> -->
          <li>
            <b-link to="/products/1/regularizacao-dados-prestack">
              Regularização de dados pré-stack
            </b-link>
          </li>
          <!-- <li>
            <b-link to="/products/1/supressao-ruidos-coerentes">
              Supressão de ruídos coerentes
            </b-link>
          </li> -->
          <li>
            <b-link to="/products/1/analise-velocidade-interativa">
              Análise de velocidade interativa
            </b-link>
          </li>
          <!-- <li>
            <b-link to="/products/1/analise-mute-interativa">
              Análise de mute interativa
            </b-link>
          </li> -->
          <li>
            <b-link to="/products/1/crs">
              Common Reflection Surface (CRS)
            </b-link>
          </li>
          <!-- <li>
            <b-link to="/products/1/migracao-prestack-kirchhoff">
              Migração pré empilhamento Kirchhoff
            </b-link>
          </li> -->
          <li>
            <b-link to="/products/1/hfe">
              Realce de altas de baixas frequências (HFE)
            </b-link>
          </li>
        </b-collapse>
      </li>
      <!-- Produtos 2 -->
      <!-- <li>
        <b-link v-b-toggle="'produtos-2'">
          Processamento 2D em profundidade
        </b-link>
        <b-collapse id="produtos-2" tag="ul" class="list-unstyled">
          <li>
            <b-link to="/products/2/analise-velocidade-tomografia">
              Análise de velocidade por tomografia
            </b-link>
          </li>
          <li>
            <b-link to="/products/2/migracao-2d-kirchhoff">
              Migração 2D tipo Kirchhoff
            </b-link>
          </li>
          <li>
            <b-link to="/products/2/migracao-2d-rtm">
              Migração 2D RTM (em desenvolvimento)
            </b-link>
          </li>
        </b-collapse>
      </li> -->
      <!-- Produtos 3 -->
      <!-- <li>
        <b-link v-b-toggle="'produtos-3'">
          Processamento 3D em tempo
        </b-link>
        <b-collapse id="produtos-3" tag="ul" class="list-unstyled">
          <li>
            <b-link to="/products/3/correcao-estatica-3d">
              Correção Estática 3D
            </b-link>
          </li>
          <li>
            <b-link to="/products/3/supressao-ruidos-cross-spread">
              Supressão de ruídos no cross-spread
            </b-link>
          </li>
          <li>
            <b-link to="/products/3/regularizacao-5d">
              Regularização 5D de dados sísmicos
            </b-link>
          </li>
        </b-collapse>
      </li> -->
      <!-- Produtos 4 -->
      <!-- <li>
        <b-link v-b-toggle="'produtos-4'">
          Processamento 3D em profundidade
        </b-link>
        <b-collapse id="produtos-4" tag="ul" class="list-unstyled">
          <li>
            <b-link to="">
              Migração RTM (em desenvolvimento)
            </b-link>
          </li>
        </b-collapse>
      </li> -->
    </ul>
  </nav>
</template>

<script>
export default {
  name: "SidebarProducts",
};
</script>

<style scoped>
p {
  color: #999;
}
.sidebar a,
a:hover,
a:focus {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s;
}

.sidebar {
  background: #ffee58;
  color: #000000;
  transition: all 0.3s;
}

.sidebar ul.components {
  padding: 20px 0;
  border-bottom: 2px solid #c9bc1f;
}

.sidebar ul p {
  color: #fff;
  padding: 10px;
}

.sidebar ul li a {
  padding: 10px;
  font-size: 1.1em;
  display: block;
}

.sidebar ul li a:hover {
  color: #000000;
  background-color: #ffff6b;
}
.sidebar ul li.active > a,
a[aria-expanded="true"] {
  color: #000000;
  background: #fdd835;
}

a[data-toggle="collapse"] {
  position: relative;
}

.dropdown-toggle::after {
  display: block;
  position: absolute;
  top: 50%;
  right: 20%;
  transform: translateY(-50%);
}
ul ul a {
  font-size: 0.9em !important;
  padding-left: 30px !important;
  background: #fdd835;
}
</style>
